import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

import noise from '../../assets/noise.svg?inline';

export default makeStyles({ name: 'Layout' })((theme) => ({
    root: {
        position: 'relative',
        width: '100vw',
        height: '100vh',
        minWidth: 1280,
        overflow: 'auto',
        background: '#17161B',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            minWidth: 0
        },
        '&:after': {
            content: '""',
            position: 'fixed',
            inset: 0,
            backgroundImage: `url(${noise})`,
            backgroundRepeat: 'repeat',
            mixBlendMode: 'multiply',
            pointerEvents: 'none'
        }
    },
    header: {
        top: 0,
        zIndex: theme.zIndex.drawer + 1,
        position: 'sticky'
    },
    aurora: {
        zIndex: 0,
        inset: 0,
        position: 'absolute'
    },
    content: {
        zIndex: 1,
        position: 'relative',
        maxWidth: 1280,
        margin: '0 auto',
        boxSizing: 'content-box',
        padding: '0 16px'
    }
}));
